import React, { useContext } from "react";
import CircleStatus from "../../../../../../components/CircleStatus";
import TableCustom from "../../../../../../components/Table";
import { useDispatch, useSelector } from "react-redux";
import {
  dayOfficeBookingListSelector,
  dayOfficeBookingPayloadSelector,
} from "../../../../selectors/BookingSelectors";
import {
  FORMAT_DATE_VARIANT_3,
  FORMAT_TIME_VARIANT_1,
} from "../../../../../App/configs/DateTimeConfigs";
import { listDayOfficeBookingPayloadAction } from "../../../../actions/BookingActions";
import {
  ROOM_STATUS_CANCELLED,
  ROOM_STATUS_COMPLETED,
  ROOM_STATUS_UPCOMING,
} from "../../../../configs/Constants";
import moment from "moment-timezone";
import { LocalizationContext } from "../../../../../../locales/Translation";
import Action from "./Action";
import SizeBox from "../../../../../../components/SizeBox";

const BookingTable = ({ columns, loading, setLoading }: any) => {
  const { translations } = useContext(LocalizationContext);

  const listDayOfficeBooking = useSelector(dayOfficeBookingListSelector);
  const dayOfficeBookingPayload = useSelector(dayOfficeBookingPayloadSelector);
  const dispatch = useDispatch();

  const renderStatusCircle = (statusId: any) => {
    switch (statusId) {
      case 0:
        return "yellow";
      case 5:
        return "yellow";
      case 1:
        return "green";
      default:
        return "blue";
    }
  };

  const decoratedData = () => {
    if (listDayOfficeBooking?.items?.length > 0) {
      return listDayOfficeBooking?.items.map((dayOffice: any, _: any) => {
        return {
          col1: (
            <div className={"table-booking__room-name table-booking__cell"}>
              <img src={dayOffice?.thumbnail} alt="" />
              <span>{dayOffice?.day_office_name}</span>
            </div>
          ),
          col2: (
            <div
              className={"table-booking__property-details table-booking__cell"}
            >
              <div className={"table-booking__property-details-item"}>
                <i className="uil uil-building" />
                <span>{dayOffice?.brand_name}</span>
              </div>
              <div className={"table-booking__property-details-item"}>
                <i className="uil uil-map" />
                <span>{dayOffice?.address}</span>
              </div>
            </div>
          ),
          col3: (
            <div className={"table-booking__cell"}>{dayOffice?.duration}</div>
          ),
          col4: (
            <div className={"table-booking__cell"}>
              {moment
                .tz(dayOffice?.booking_start_time * 1000, dayOffice?.timezone)
                .format(FORMAT_DATE_VARIANT_3)}{" "}
              <br />
              {moment
                .tz(dayOffice?.booking_start_time * 1000, dayOffice?.timezone)
                .format(FORMAT_TIME_VARIANT_1)}{" "}
              -{" "}
              {moment
                .tz(dayOffice?.booking_end_time * 1000, dayOffice?.timezone)
                .format(FORMAT_TIME_VARIANT_1)}
            </div>
          ),
          col5: (
            <div className={"table-booking__cell"}>
              {dayOffice?.currency} {dayOffice?.total_final_price}
            </div>
          ),
          col6: (
            <div className={"table-booking__cell"}>
              {dayOfficeBookingPayload?.status === ROOM_STATUS_UPCOMING ? (
                <div className={"table-booking__status"}>
                  <CircleStatus
                    color={renderStatusCircle(dayOffice?.status_id)}
                  />
                  <span>
                    {translations.roomBookingStatus[dayOffice?.status_id]}
                  </span>
                </div>
              ) : null}
              {dayOfficeBookingPayload?.status === ROOM_STATUS_COMPLETED
                ? null
                : null}
              {dayOfficeBookingPayload?.status === ROOM_STATUS_CANCELLED ? (
                <>
                  {moment
                    .tz(dayOffice?.updated_at * 1000, dayOffice?.timezone)
                    .format(FORMAT_DATE_VARIANT_3)}
                  <br />
                  {moment
                    .tz(dayOffice?.updated_at * 1000, dayOffice?.timezone)
                    .format(FORMAT_TIME_VARIANT_1)}
                </>
              ) : null}

              {dayOffice?.parking_request ? (
                <>
                  <SizeBox height={16} />
                  <div>
                    <b>Parking:</b> {dayOffice?.parking_request?.status?.text}
                  </div>
                </>
              ) : null}
            </div>
          ),
          col7: (
            <Action
              loading={loading}
              setLoading={setLoading}
              cancellationPolicy={dayOffice?.cancellation_policy}
              status={dayOfficeBookingPayload?.status}
              isRequestCancel={dayOffice?.request_cancel}
              bookingId={dayOffice?.booking_id}
              dayOfficeId={dayOffice?.day_office_id}
            />
          ),
        };
      });
    }
    return [];
  };

  return (
    <TableCustom
      showTotal={false}
      columns={columns}
      currentPage={dayOfficeBookingPayload?.page}
      loading={loading}
      tableClass={"table-booking"}
      tableData={decoratedData()}
      itemPerPage={listDayOfficeBooking?.pagination?.limit}
      totalItems={listDayOfficeBooking?.pagination?.total}
      onChangePagination={(e: any, { activePage }: any) => {
        dispatch(
          listDayOfficeBookingPayloadAction({
            page: activePage,
          })
        );
      }}
    />
  );
};

export default BookingTable;
